// Translations for the Louis Vuitton second-hand shop

export const translations = {
  de: {
    // Navigation
    nav: {
      collection: 'Kollektion',
      howItWorks: 'So funktioniert\'s',
      about: 'Über uns',
      backToHome: 'Zurück zur Startseite'
    },
    
    // Hero Section
    hero: {
      badge: 'Authentifizierte Luxusware',
      title: 'Zeitlose Louis Vuitton',
      subtitle: 'Eleganz aus zweiter Hand',
      description: 'Entdecken Sie authentifizierte Louis Vuitton Schätze zu aussergewöhnlichen Preisen.',
      descriptionLine2: 'Jedes Stück erzählt eine Geschichte.',
      descriptionLine3: 'Nachhaltiger Luxus, zeitloser Stil.',
      searchPlaceholder: 'Suche nach Taschen, Accessoires...',
      exploreCollection: 'Kollektion entdecken',
      learnMore: 'Mehr erfahren'
    },
    
    // Trust Badges
    trustBadges: {
      authenticated: '100% Authentifiziert',
      shipping: 'Versicherte Lieferung',
      curated: 'Expertenauswahl'
    },
    
    // Stats
    stats: {
      piecesSold: 'Verkaufte Stücke',
      satisfactionRate: 'Zufriedenheitsrate',
      authenticated: 'Authentifiziert',
      seeOnRicardo: 'siehe auf ricardo.ch'
    },
    
    // Featured Collection
    featuredCollection: {
      title: 'Ausgewählte Kollektion',
      subtitle: 'Handverlesene authentifizierte Louis Vuitton Stücke',
      subtitleLine2: 'mehr Informationen wie Fotos und Videos auf Anfrage per WhatsApp',
      viewAll: 'Gesamte Kollektion ansehen'
    },
    
    // Product Card
    product: {
      contactUs: 'Kontaktieren Sie uns'
    },
    
    // How It Works
    howItWorks: {
      title: 'So funktioniert\'s',
      subtitle: 'Ihr Weg zum authentifizierten Luxus in vier einfachen Schritten',
      step1Title: 'Kollektion durchsuchen',
      step1Desc: 'Erkunden Sie unsere kuratierte Auswahl an authentifizierten Louis Vuitton Stücken mit detaillierten Zustandsberichten und hochwertigen Bildern.',
      step2Title: 'Authentifizierungs-Garantie',
      step2Desc: 'Jeder Artikel wird von Luxusgüter-Experten streng geprüft. Wir stellen bei jedem Kauf Echtheits Bestätigungen aus.',
      step2Extra: 'Vorgängige Besichtigung jederzeit nach Absprache möglich',
      step3Title: 'Sicherer Kauf',
      step3Desc: 'Geniessen Sie sichere Kaufabwicklung mit Käuferschutz. Wir bieten Versand mit Vollversicherung.',
      step3Extra: 'Bezahlmöglichkeiten: per Vorauszahlung auf Bankkonto, Bar, Twint oder Debit/Kreditkarten',
      step4Title: 'Geniessen Sie Ihren Luxus',
      step4Desc: 'Erhalten Sie Ihren authentifizierten Louis Vuitton Schatz.'
    },
    
    // Authentication Section
    authentication: {
      badge: 'Unser Versprechen',
      title: '100% Authentifizierungs',
      titleLine2: 'Garantie',
      description: 'Jedes Louis Vuitton Stück in unserer Kollektion durchläuft eine strenge Authentifizierung durch zertifizierte Luxusgüter-Experten mit über 15 Jahren Erfahrung.',
      check1: 'Mehrstufiger Inspektionsprozess',
      check2: 'Verifizierte Seriennummern und Datumscodes',
      check3: 'Material- und Handwerksanalyse',
      check4: 'Echtheits Bestätigung inklusive',
      check5: 'LASSEN SIE IHRE TASCHE VON UNS ÜBERPRÜFEN',
      check5Small: 'CHF 19.90 per TWINT',
      learnMore: 'Mehr über unseren Prozess erfahren'
    },
    
    // Buy-back Section
    buyback: {
      title: 'ANKAUF',
      description: 'Wir kaufen ihre gut erhaltene Tasche an. Vorteil bei Love Luxe - Sie erhalten sofort Geld und nicht erst beim erfolgreichen Verkauf durch uns. Natürlich verkaufen wir die Tasche auch auf Kommisson - Sie erhalten Ihr Geld erst bei erfolgreichem Verkauf.'
    },
    
    // Testimonials
    testimonials: {
      title: 'Geliebt von Luxus-Enthusiasten',
      subtitle: 'Hören Sie, was unsere Kunden über ihre Erfahrung sagen'
    },
    
    // Newsletter
    newsletter: {
      title: 'Bleiben Sie informiert',
      subtitle: 'Abonnieren Sie, um exklusiven Erstzugang zu Neuankünften und Sonderangeboten zu erhalten',
      placeholder: 'Ihre E-Mail-Adresse',
      subscribe: 'Abonnieren',
      success: 'Vielen Dank für Ihr Abonnement!',
      alreadySubscribed: 'Diese E-Mail ist bereits abonniert!',
      error: 'Fehler beim Abonnieren. Bitte versuchen Sie es erneut.'
    },
    
    // Footer
    footer: {
      tagline: 'Kuratierung authentifizierter Louis Vuitton Stücke für den modernen Luxus-Enthusiasten.',
      shop: 'Shop',
      handbags: 'Handtaschen',
      accessories: 'Accessoires',
      newArrivals: 'Neuankünfte',
      bestSellers: 'Bestseller',
      support: 'Support',
      authentication: 'Authentifizierung',
      shippingReturns: 'Versand & Rückgabe',
      faq: 'FAQ',
      contactUs: 'Kontakt',
      contact: 'Kontakt',
      privacyPolicy: 'Datenschutz',
      termsOfService: 'AGB',
      cookiePolicy: 'Cookie-Richtlinie',
      allRightsReserved: 'Alle Rechte vorbehalten.',
      exportInquiries: 'Anfragen exportieren'
    },
    
    // Collection Page
    collectionPage: {
      title: 'Komplette Kollektion',
      itemsAvailable: 'authentifizierte Louis Vuitton Stücke verfügbar',
      searchPlaceholder: 'Kollektion durchsuchen...',
      allCategories: 'Alle Kategorien',
      sortBy: 'Sortieren nach',
      featuredFirst: 'Empfohlene zuerst',
      priceLowHigh: 'Preis: Niedrig bis Hoch',
      priceHighLow: 'Preis: Hoch bis Niedrig',
      nameAZ: 'Name: A-Z',
      allConditions: 'Alle Zustände',
      excellent: 'Ausgezeichnet',
      veryGood: 'Sehr gut',
      featured: 'Empfohlen',
      noProducts: 'Keine Produkte gefunden',
      noProductsDesc: 'Versuchen Sie, Ihre Filter oder Suchanfrage anzupassen',
      clearFilters: 'Alle Filter löschen'
    },
    
    // Contact Modal
    contactModal: {
      title: 'Kontaktieren Sie uns',
      inquiringAbout: 'Anfrage bezüglich:',
      getInTouch: 'Nehmen Sie Kontakt mit uns auf für weitere Informationen',
      fullName: 'Vollständiger Name',
      fullNamePlaceholder: 'Ihr Name',
      email: 'E-Mail-Adresse',
      emailPlaceholder: 'ihre.email@beispiel.com',
      phone: 'Telefonnummer',
      phonePlaceholder: '+41 41 543 36 77',
      message: 'Nachricht',
      messagePlaceholder: 'Erzählen Sie uns von Ihrer Anfrage...',
      cancel: 'Abbrechen',
      sending: 'Wird gesendet...',
      sendMessage: 'Nachricht senden',
      successTitle: 'Nachricht gesendet!',
      successMessage: 'Wir melden uns innerhalb von 24 Stunden bei Ihnen.'
    },
    
    // Wishlist
    wishlist: {
      addedToWishlist: 'Zur Wunschliste hinzugefügt!',
      mockMessage: '(Mock: Noch kein Backend)'
    }
  },
  
  en: {
    // Navigation
    nav: {
      collection: 'Collection',
      howItWorks: 'How It Works',
      about: 'About',
      backToHome: 'Back to Home'
    },
    
    // Hero Section
    hero: {
      badge: 'Authenticated Luxury',
      title: 'Timeless Louis Vuitton',
      subtitle: 'Pre-Loved Elegance',
      description: 'Discover authenticated Louis Vuitton treasures at exceptional prices.',
      descriptionLine2: 'Every piece tells a story.',
      descriptionLine3: 'Sustainable luxury, timeless style.',
      searchPlaceholder: 'Search for bags, accessories...',
      exploreCollection: 'Explore Collection',
      learnMore: 'Learn More'
    },
    
    // Trust Badges
    trustBadges: {
      authenticated: '100% Authenticated',
      shipping: 'Insured Shipping',
      curated: 'Expert Curated'
    },
    
    // Stats
    stats: {
      piecesSold: 'Pieces Sold',
      satisfactionRate: 'Satisfaction Rate',
      authenticated: 'Authenticated',
      seeOnRicardo: 'see on ricardo.ch'
    },
    
    // Featured Collection
    featuredCollection: {
      title: 'Featured Collection',
      subtitle: 'Handpicked authenticated Louis Vuitton pieces',
      subtitleLine2: 'more information like photos and videos available on request via WhatsApp',
      viewAll: 'View All Collection'
    },
    
    // Product Card
    product: {
      contactUs: 'Contact Us'
    },
    
    // How It Works
    howItWorks: {
      title: 'How It Works',
      subtitle: 'Your journey to authenticated luxury in four simple steps',
      step1Title: 'Browse Collection',
      step1Desc: 'Explore our curated selection of authenticated Louis Vuitton pieces, each with detailed condition reports and high-quality images.',
      step2Title: 'Authentication Guarantee',
      step2Desc: 'Every item undergoes rigorous authentication by luxury goods experts. We provide confirmation of authenticity with each purchase.',
      step2Extra: 'Prior viewing possible at any time by arrangement',
      step3Title: 'Secure Purchase',
      step3Desc: 'Enjoy secure checkout with buyer protection. We offer shipping with full insurance.',
      step3Extra: 'Payment options: Advance payment to bank account, Cash, Twint or Debit/Credit cards',
      step4Title: 'Love Your Luxury',
      step4Desc: 'Receive your authenticated Louis Vuitton treasure.'
    },
    
    // Authentication Section
    authentication: {
      badge: 'Our Promise',
      title: '100% Authentication',
      titleLine2: 'Guarantee',
      description: 'Every Louis Vuitton piece in our collection undergoes rigorous authentication by certified luxury goods experts with over 15 years of experience.',
      check1: 'Multi-point inspection process',
      check2: 'Verified serial numbers and date codes',
      check3: 'Material and craftsmanship analysis',
      check4: 'Confirmation of authenticity included',
      check5: 'LET US VERIFY YOUR BAG',
      check5Small: 'CHF 19.90 via TWINT',
      learnMore: 'Learn About Our Process'
    },
    
    // Buy-back Section
    buyback: {
      title: 'BUY-BACK',
      description: 'We purchase your well-maintained bag. Advantage at Love Luxe - You receive money immediately and not only after a successful sale by us. Of course, we also sell the bag on commission - You receive your money only after a successful sale.'
    },
    
    // Testimonials
    testimonials: {
      title: 'Loved by Luxury Enthusiasts',
      subtitle: 'Hear what our clients say about their experience'
    },
    
    // Newsletter
    newsletter: {
      title: 'Stay Informed',
      subtitle: 'Subscribe to receive exclusive first access to new arrivals and special offers',
      placeholder: 'Your email address',
      subscribe: 'Subscribe',
      success: 'Thank you for subscribing to our newsletter!',
      alreadySubscribed: 'This email is already subscribed!',
      error: 'Error subscribing. Please try again.'
    },
    
    // Footer
    footer: {
      tagline: 'Curating authenticated Louis Vuitton pieces for the modern luxury enthusiast.',
      shop: 'Shop',
      handbags: 'Handbags',
      accessories: 'Accessories',
      newArrivals: 'New Arrivals',
      bestSellers: 'Best Sellers',
      support: 'Support',
      authentication: 'Authentication',
      shippingReturns: 'Shipping & Returns',
      faq: 'FAQ',
      contactUs: 'Contact Us',
      contact: 'Contact',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      cookiePolicy: 'Cookie Policy',
      allRightsReserved: 'All rights reserved.',
      exportInquiries: 'Export Inquiries'
    },
    
    // Collection Page
    collectionPage: {
      title: 'Complete Collection',
      itemsAvailable: 'authenticated Louis Vuitton pieces available',
      searchPlaceholder: 'Search collection...',
      allCategories: 'All Categories',
      sortBy: 'Sort by',
      featuredFirst: 'Featured First',
      priceLowHigh: 'Price: Low to High',
      priceHighLow: 'Price: High to Low',
      nameAZ: 'Name: A-Z',
      allConditions: 'All Conditions',
      excellent: 'Excellent',
      veryGood: 'Very Good',
      featured: 'Featured',
      noProducts: 'No products found',
      noProductsDesc: 'Try adjusting your filters or search query',
      clearFilters: 'Clear All Filters'
    },
    
    // Contact Modal
    contactModal: {
      title: 'Contact Us',
      inquiringAbout: 'Inquiring about:',
      getInTouch: 'Get in touch with us for more information',
      fullName: 'Full Name',
      fullNamePlaceholder: 'Your name',
      email: 'Email Address',
      emailPlaceholder: 'your.email@example.com',
      phone: 'Phone Number',
      phonePlaceholder: '+41 41 543 36 77',
      message: 'Message',
      messagePlaceholder: 'Tell us about your inquiry...',
      cancel: 'Cancel',
      sending: 'Sending...',
      sendMessage: 'Send Message',
      successTitle: 'Message Sent!',
      successMessage: 'We\'ll get back to you within 24 hours.'
    },
    
    // Wishlist
    wishlist: {
      addedToWishlist: 'Added to wishlist!',
      mockMessage: '(Mock: No backend yet)'
    }
  }
};

export default translations;
